<template>
  <div class="card3">
    <div class="card3-imgs">
      <img @click.prevent
           :src="banner"
           width="100%">
    </div>
    <div class="card3-txts">
      <h4>{{title}}</h4>
      <p v-html="des"></p>
      <h4 v-if="infosTitle">{{ infosTitle }}</h4>
      <p class="card3-txts-p"
         v-for="(info, index) in infos"
         :key="index">
        <span class="card3-icon"
              :style="{'background': 'url('+ require('images/service/icon.png') + ') center center / 100% 100%'}"></span>
        <span v-html="info.txt"></span>
      </p>
    </div>
    <slot></slot>
  </div>
</template>

<script>

export default {
  name: '',
  props: {
    banner: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    des: {
      type: String,
      default: ''
    },
    infosTitle: {
      type: String,
      default: ''
    },
    infos: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
    }
  },
  components: {},
  watch: {},
  computed: {},
  created () { },
  mounted () { },
  methods: {}
}

</script>
<style lang='scss' scoped>
@import "px2rem";

.card3 {
  &-imgs {
    width: px2rem(345);
    margin: 0 auto;
    font-size: 0;
  }
  &-txts {
    h4 {
      font-size: px2rem(14);
      color: #3c3c3c;
      font-weight: bold;
      padding: px2rem(18) 0 px2rem(15);
    }
    p {
      font-size: px2rem(13);
      color: #666666;
      line-height: px2rem(20);
    }
    &-p {
      padding-top: px2rem(10);
    }
  }
  &-icon {
    display: inline-block;
    width: px2rem(9);
    height: px2rem(9);
    background: #666666;
    margin-right: px2rem(6);
  }
}
</style>
